// source: integration_proto.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var credentials_proto_pb = require('./credentials_proto_pb.js');
goog.object.extend(proto, credentials_proto_pb);
var identity_record_proto_pb = require('./identity_record_proto_pb.js');
goog.object.extend(proto, identity_record_proto_pb);
var timestamp_proto_pb = require('./timestamp_proto_pb.js');
goog.object.extend(proto, timestamp_proto_pb);
goog.exportSymbol('proto.IntegrationConnection', null, global);
goog.exportSymbol('proto.IntegrationConnection.Status', null, global);
goog.exportSymbol('proto.IntegrationHeartbeat', null, global);
goog.exportSymbol('proto.IntegrationResponse', null, global);
goog.exportSymbol('proto.IntegrationResponse.ConfigCase', null, global);
goog.exportSymbol('proto.IntegrationResponse.FederatedTakServer', null, global);
goog.exportSymbol('proto.IntegrationResponse.Sitx', null, global);
goog.exportSymbol('proto.IntegrationResponse.TakConfig', null, global);
goog.exportSymbol('proto.IntegrationResponse.TakServer', null, global);
goog.exportSymbol('proto.IntegrationResponse.Webhook', null, global);
goog.exportSymbol('proto.IntegrationResponse.Webhook.CredentialsCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationHeartbeat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationHeartbeat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationHeartbeat.displayName = 'proto.IntegrationHeartbeat';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.IntegrationResponse.oneofGroups_);
};
goog.inherits(proto.IntegrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.displayName = 'proto.IntegrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse.TakServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationResponse.TakServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.TakServer.displayName = 'proto.IntegrationResponse.TakServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse.Sitx = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationResponse.Sitx, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.Sitx.displayName = 'proto.IntegrationResponse.Sitx';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse.Webhook = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.IntegrationResponse.Webhook.oneofGroups_);
};
goog.inherits(proto.IntegrationResponse.Webhook, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.Webhook.displayName = 'proto.IntegrationResponse.Webhook';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse.FederatedTakServer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationResponse.FederatedTakServer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.FederatedTakServer.displayName = 'proto.IntegrationResponse.FederatedTakServer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationResponse.TakConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationResponse.TakConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationResponse.TakConfig.displayName = 'proto.IntegrationResponse.TakConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.IntegrationConnection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.IntegrationConnection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.IntegrationConnection.displayName = 'proto.IntegrationConnection';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationHeartbeat.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationHeartbeat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationHeartbeat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationHeartbeat.toObject = function(includeInstance, msg) {
  var f, obj = {
inbound: (f = msg.getInbound()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
outbound: (f = msg.getOutbound()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
lastConnect: (f = msg.getLastConnect()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f),
lastDisconnect: (f = msg.getLastDisconnect()) && timestamp_proto_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationHeartbeat}
 */
proto.IntegrationHeartbeat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationHeartbeat;
  return proto.IntegrationHeartbeat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationHeartbeat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationHeartbeat}
 */
proto.IntegrationHeartbeat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setInbound(value);
      break;
    case 5:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOutbound(value);
      break;
    case 6:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastConnect(value);
      break;
    case 7:
      var value = new timestamp_proto_pb.Timestamp;
      reader.readMessage(value,timestamp_proto_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastDisconnect(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationHeartbeat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationHeartbeat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationHeartbeat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationHeartbeat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInbound();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOutbound();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastConnect();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastDisconnect();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      timestamp_proto_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional Timestamp inbound = 4;
 * @return {?proto.Timestamp}
 */
proto.IntegrationHeartbeat.prototype.getInbound = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 4));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.IntegrationHeartbeat} returns this
*/
proto.IntegrationHeartbeat.prototype.setInbound = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationHeartbeat} returns this
 */
proto.IntegrationHeartbeat.prototype.clearInbound = function() {
  return this.setInbound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationHeartbeat.prototype.hasInbound = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Timestamp outbound = 5;
 * @return {?proto.Timestamp}
 */
proto.IntegrationHeartbeat.prototype.getOutbound = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 5));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.IntegrationHeartbeat} returns this
*/
proto.IntegrationHeartbeat.prototype.setOutbound = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationHeartbeat} returns this
 */
proto.IntegrationHeartbeat.prototype.clearOutbound = function() {
  return this.setOutbound(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationHeartbeat.prototype.hasOutbound = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Timestamp last_connect = 6;
 * @return {?proto.Timestamp}
 */
proto.IntegrationHeartbeat.prototype.getLastConnect = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 6));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.IntegrationHeartbeat} returns this
*/
proto.IntegrationHeartbeat.prototype.setLastConnect = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationHeartbeat} returns this
 */
proto.IntegrationHeartbeat.prototype.clearLastConnect = function() {
  return this.setLastConnect(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationHeartbeat.prototype.hasLastConnect = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Timestamp last_disconnect = 7;
 * @return {?proto.Timestamp}
 */
proto.IntegrationHeartbeat.prototype.getLastDisconnect = function() {
  return /** @type{?proto.Timestamp} */ (
    jspb.Message.getWrapperField(this, timestamp_proto_pb.Timestamp, 7));
};


/**
 * @param {?proto.Timestamp|undefined} value
 * @return {!proto.IntegrationHeartbeat} returns this
*/
proto.IntegrationHeartbeat.prototype.setLastDisconnect = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationHeartbeat} returns this
 */
proto.IntegrationHeartbeat.prototype.clearLastDisconnect = function() {
  return this.setLastDisconnect(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationHeartbeat.prototype.hasLastDisconnect = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.IntegrationResponse.oneofGroups_ = [[7,8,9,10]];

/**
 * @enum {number}
 */
proto.IntegrationResponse.ConfigCase = {
  CONFIG_NOT_SET: 0,
  TAK_SERVER: 7,
  WEBHOOK: 8,
  FEDERATED_TAK_SERVER: 9,
  SITX: 10
};

/**
 * @return {proto.IntegrationResponse.ConfigCase}
 */
proto.IntegrationResponse.prototype.getConfigCase = function() {
  return /** @type {proto.IntegrationResponse.ConfigCase} */(jspb.Message.computeOneofCase(this, proto.IntegrationResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
identity: (f = msg.getIdentity()) && identity_record_proto_pb.IdentityRecord.toObject(includeInstance, f),
takServer: (f = msg.getTakServer()) && proto.IntegrationResponse.TakServer.toObject(includeInstance, f),
webhook: (f = msg.getWebhook()) && proto.IntegrationResponse.Webhook.toObject(includeInstance, f),
federatedTakServer: (f = msg.getFederatedTakServer()) && proto.IntegrationResponse.FederatedTakServer.toObject(includeInstance, f),
sitx: (f = msg.getSitx()) && proto.IntegrationResponse.Sitx.toObject(includeInstance, f),
takConfig: (f = msg.getTakConfig()) && proto.IntegrationResponse.TakConfig.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse}
 */
proto.IntegrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse;
  return proto.IntegrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse}
 */
proto.IntegrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new identity_record_proto_pb.IdentityRecord;
      reader.readMessage(value,identity_record_proto_pb.IdentityRecord.deserializeBinaryFromReader);
      msg.setIdentity(value);
      break;
    case 7:
      var value = new proto.IntegrationResponse.TakServer;
      reader.readMessage(value,proto.IntegrationResponse.TakServer.deserializeBinaryFromReader);
      msg.setTakServer(value);
      break;
    case 8:
      var value = new proto.IntegrationResponse.Webhook;
      reader.readMessage(value,proto.IntegrationResponse.Webhook.deserializeBinaryFromReader);
      msg.setWebhook(value);
      break;
    case 9:
      var value = new proto.IntegrationResponse.FederatedTakServer;
      reader.readMessage(value,proto.IntegrationResponse.FederatedTakServer.deserializeBinaryFromReader);
      msg.setFederatedTakServer(value);
      break;
    case 10:
      var value = new proto.IntegrationResponse.Sitx;
      reader.readMessage(value,proto.IntegrationResponse.Sitx.deserializeBinaryFromReader);
      msg.setSitx(value);
      break;
    case 11:
      var value = new proto.IntegrationResponse.TakConfig;
      reader.readMessage(value,proto.IntegrationResponse.TakConfig.deserializeBinaryFromReader);
      msg.setTakConfig(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdentity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      identity_record_proto_pb.IdentityRecord.serializeBinaryToWriter
    );
  }
  f = message.getTakServer();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.IntegrationResponse.TakServer.serializeBinaryToWriter
    );
  }
  f = message.getWebhook();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.IntegrationResponse.Webhook.serializeBinaryToWriter
    );
  }
  f = message.getFederatedTakServer();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.IntegrationResponse.FederatedTakServer.serializeBinaryToWriter
    );
  }
  f = message.getSitx();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.IntegrationResponse.Sitx.serializeBinaryToWriter
    );
  }
  f = message.getTakConfig();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.IntegrationResponse.TakConfig.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.TakServer.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.TakServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse.TakServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.TakServer.toObject = function(includeInstance, msg) {
  var f, obj = {
host: jspb.Message.getFieldWithDefault(msg, 1, ""),
port: jspb.Message.getFieldWithDefault(msg, 2, 0),
serverCert: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
serverCertPassword: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
clientCert: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
clientCertPassword: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
udp: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
dataFormat: (f = jspb.Message.getField(msg, 8)) == null ? undefined : f,
sample: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse.TakServer}
 */
proto.IntegrationResponse.TakServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse.TakServer;
  return proto.IntegrationResponse.TakServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse.TakServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse.TakServer}
 */
proto.IntegrationResponse.TakServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setHost(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPort(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerCert(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerCertPassword(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientCert(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientCertPassword(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUdp(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataFormat(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSample(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.TakServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.TakServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse.TakServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.TakServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHost();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPort();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getUdp();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSample();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional string host = 1;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getHost = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setHost = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 port = 2;
 * @return {number}
 */
proto.IntegrationResponse.TakServer.prototype.getPort = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setPort = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string server_cert = 3;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getServerCert = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setServerCert = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.clearServerCert = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.hasServerCert = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string server_cert_password = 4;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getServerCertPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setServerCertPassword = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.clearServerCertPassword = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.hasServerCertPassword = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string client_cert = 5;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getClientCert = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setClientCert = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.clearClientCert = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.hasClientCert = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string client_cert_password = 6;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getClientCertPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setClientCertPassword = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.clearClientCertPassword = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.hasClientCertPassword = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool udp = 7;
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.getUdp = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setUdp = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string data_format = 8;
 * @return {string}
 */
proto.IntegrationResponse.TakServer.prototype.getDataFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setDataFormat = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.clearDataFormat = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.hasDataFormat = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool sample = 9;
 * @return {boolean}
 */
proto.IntegrationResponse.TakServer.prototype.getSample = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.IntegrationResponse.TakServer} returns this
 */
proto.IntegrationResponse.TakServer.prototype.setSample = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.Sitx.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.Sitx.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse.Sitx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.Sitx.toObject = function(includeInstance, msg) {
  var f, obj = {
organization: jspb.Message.getFieldWithDefault(msg, 1, ""),
path: jspb.Message.getFieldWithDefault(msg, 2, ""),
clientId: jspb.Message.getFieldWithDefault(msg, 3, ""),
clientSecret: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse.Sitx}
 */
proto.IntegrationResponse.Sitx.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse.Sitx;
  return proto.IntegrationResponse.Sitx.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse.Sitx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse.Sitx}
 */
proto.IntegrationResponse.Sitx.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrganization(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.Sitx.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.Sitx.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse.Sitx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.Sitx.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string organization = 1;
 * @return {string}
 */
proto.IntegrationResponse.Sitx.prototype.getOrganization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.Sitx} returns this
 */
proto.IntegrationResponse.Sitx.prototype.setOrganization = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string path = 2;
 * @return {string}
 */
proto.IntegrationResponse.Sitx.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.Sitx} returns this
 */
proto.IntegrationResponse.Sitx.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client_id = 3;
 * @return {string}
 */
proto.IntegrationResponse.Sitx.prototype.getClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.Sitx} returns this
 */
proto.IntegrationResponse.Sitx.prototype.setClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string client_secret = 4;
 * @return {string}
 */
proto.IntegrationResponse.Sitx.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.Sitx} returns this
 */
proto.IntegrationResponse.Sitx.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.IntegrationResponse.Webhook.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.IntegrationResponse.Webhook.CredentialsCase = {
  CREDENTIALS_NOT_SET: 0,
  BASIC: 7,
  JSON: 8
};

/**
 * @return {proto.IntegrationResponse.Webhook.CredentialsCase}
 */
proto.IntegrationResponse.Webhook.prototype.getCredentialsCase = function() {
  return /** @type {proto.IntegrationResponse.Webhook.CredentialsCase} */(jspb.Message.computeOneofCase(this, proto.IntegrationResponse.Webhook.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.Webhook.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.Webhook.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse.Webhook} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.Webhook.toObject = function(includeInstance, msg) {
  var f, obj = {
url: jspb.Message.getFieldWithDefault(msg, 1, ""),
basic: (f = msg.getBasic()) && credentials_proto_pb.BasicCredentials.toObject(includeInstance, f),
json: (f = msg.getJson()) && credentials_proto_pb.JsonCredentials.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse.Webhook}
 */
proto.IntegrationResponse.Webhook.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse.Webhook;
  return proto.IntegrationResponse.Webhook.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse.Webhook} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse.Webhook}
 */
proto.IntegrationResponse.Webhook.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 7:
      var value = new credentials_proto_pb.BasicCredentials;
      reader.readMessage(value,credentials_proto_pb.BasicCredentials.deserializeBinaryFromReader);
      msg.setBasic(value);
      break;
    case 8:
      var value = new credentials_proto_pb.JsonCredentials;
      reader.readMessage(value,credentials_proto_pb.JsonCredentials.deserializeBinaryFromReader);
      msg.setJson(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.Webhook.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.Webhook.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse.Webhook} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.Webhook.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBasic();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      credentials_proto_pb.BasicCredentials.serializeBinaryToWriter
    );
  }
  f = message.getJson();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      credentials_proto_pb.JsonCredentials.serializeBinaryToWriter
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.IntegrationResponse.Webhook.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.Webhook} returns this
 */
proto.IntegrationResponse.Webhook.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BasicCredentials basic = 7;
 * @return {?proto.BasicCredentials}
 */
proto.IntegrationResponse.Webhook.prototype.getBasic = function() {
  return /** @type{?proto.BasicCredentials} */ (
    jspb.Message.getWrapperField(this, credentials_proto_pb.BasicCredentials, 7));
};


/**
 * @param {?proto.BasicCredentials|undefined} value
 * @return {!proto.IntegrationResponse.Webhook} returns this
*/
proto.IntegrationResponse.Webhook.prototype.setBasic = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.IntegrationResponse.Webhook.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse.Webhook} returns this
 */
proto.IntegrationResponse.Webhook.prototype.clearBasic = function() {
  return this.setBasic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.Webhook.prototype.hasBasic = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional JsonCredentials json = 8;
 * @return {?proto.JsonCredentials}
 */
proto.IntegrationResponse.Webhook.prototype.getJson = function() {
  return /** @type{?proto.JsonCredentials} */ (
    jspb.Message.getWrapperField(this, credentials_proto_pb.JsonCredentials, 8));
};


/**
 * @param {?proto.JsonCredentials|undefined} value
 * @return {!proto.IntegrationResponse.Webhook} returns this
*/
proto.IntegrationResponse.Webhook.prototype.setJson = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.IntegrationResponse.Webhook.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse.Webhook} returns this
 */
proto.IntegrationResponse.Webhook.prototype.clearJson = function() {
  return this.setJson(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.Webhook.prototype.hasJson = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.FederatedTakServer.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.FederatedTakServer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse.FederatedTakServer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.FederatedTakServer.toObject = function(includeInstance, msg) {
  var f, obj = {
serverCert: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse.FederatedTakServer}
 */
proto.IntegrationResponse.FederatedTakServer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse.FederatedTakServer;
  return proto.IntegrationResponse.FederatedTakServer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse.FederatedTakServer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse.FederatedTakServer}
 */
proto.IntegrationResponse.FederatedTakServer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setServerCert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.FederatedTakServer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.FederatedTakServer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse.FederatedTakServer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.FederatedTakServer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getServerCert();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string server_cert = 1;
 * @return {string}
 */
proto.IntegrationResponse.FederatedTakServer.prototype.getServerCert = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.FederatedTakServer} returns this
 */
proto.IntegrationResponse.FederatedTakServer.prototype.setServerCert = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationResponse.TakConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationResponse.TakConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationResponse.TakConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.TakConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
defaultWorkspaceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
inboundEnabled: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
outboundEnabled: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
addFutureWorkspaces: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationResponse.TakConfig}
 */
proto.IntegrationResponse.TakConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationResponse.TakConfig;
  return proto.IntegrationResponse.TakConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationResponse.TakConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationResponse.TakConfig}
 */
proto.IntegrationResponse.TakConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultWorkspaceId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInboundEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOutboundEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAddFutureWorkspaces(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationResponse.TakConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationResponse.TakConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationResponse.TakConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationResponse.TakConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string default_workspace_id = 1;
 * @return {string}
 */
proto.IntegrationResponse.TakConfig.prototype.getDefaultWorkspaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.setDefaultWorkspaceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.clearDefaultWorkspaceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.hasDefaultWorkspaceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool inbound_enabled = 2;
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.getInboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.setInboundEnabled = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.clearInboundEnabled = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.hasInboundEnabled = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool outbound_enabled = 3;
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.getOutboundEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.setOutboundEnabled = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.clearOutboundEnabled = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.hasOutboundEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool add_future_workspaces = 4;
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.getAddFutureWorkspaces = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.setAddFutureWorkspaces = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.IntegrationResponse.TakConfig} returns this
 */
proto.IntegrationResponse.TakConfig.prototype.clearAddFutureWorkspaces = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.TakConfig.prototype.hasAddFutureWorkspaces = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional IdentityRecord identity = 1;
 * @return {?proto.IdentityRecord}
 */
proto.IntegrationResponse.prototype.getIdentity = function() {
  return /** @type{?proto.IdentityRecord} */ (
    jspb.Message.getWrapperField(this, identity_record_proto_pb.IdentityRecord, 1));
};


/**
 * @param {?proto.IdentityRecord|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearIdentity = function() {
  return this.setIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasIdentity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TakServer tak_server = 7;
 * @return {?proto.IntegrationResponse.TakServer}
 */
proto.IntegrationResponse.prototype.getTakServer = function() {
  return /** @type{?proto.IntegrationResponse.TakServer} */ (
    jspb.Message.getWrapperField(this, proto.IntegrationResponse.TakServer, 7));
};


/**
 * @param {?proto.IntegrationResponse.TakServer|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setTakServer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.IntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearTakServer = function() {
  return this.setTakServer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasTakServer = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Webhook webhook = 8;
 * @return {?proto.IntegrationResponse.Webhook}
 */
proto.IntegrationResponse.prototype.getWebhook = function() {
  return /** @type{?proto.IntegrationResponse.Webhook} */ (
    jspb.Message.getWrapperField(this, proto.IntegrationResponse.Webhook, 8));
};


/**
 * @param {?proto.IntegrationResponse.Webhook|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setWebhook = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.IntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearWebhook = function() {
  return this.setWebhook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasWebhook = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional FederatedTakServer federated_tak_server = 9;
 * @return {?proto.IntegrationResponse.FederatedTakServer}
 */
proto.IntegrationResponse.prototype.getFederatedTakServer = function() {
  return /** @type{?proto.IntegrationResponse.FederatedTakServer} */ (
    jspb.Message.getWrapperField(this, proto.IntegrationResponse.FederatedTakServer, 9));
};


/**
 * @param {?proto.IntegrationResponse.FederatedTakServer|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setFederatedTakServer = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.IntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearFederatedTakServer = function() {
  return this.setFederatedTakServer(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasFederatedTakServer = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Sitx sitx = 10;
 * @return {?proto.IntegrationResponse.Sitx}
 */
proto.IntegrationResponse.prototype.getSitx = function() {
  return /** @type{?proto.IntegrationResponse.Sitx} */ (
    jspb.Message.getWrapperField(this, proto.IntegrationResponse.Sitx, 10));
};


/**
 * @param {?proto.IntegrationResponse.Sitx|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setSitx = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.IntegrationResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearSitx = function() {
  return this.setSitx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasSitx = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional TakConfig tak_config = 11;
 * @return {?proto.IntegrationResponse.TakConfig}
 */
proto.IntegrationResponse.prototype.getTakConfig = function() {
  return /** @type{?proto.IntegrationResponse.TakConfig} */ (
    jspb.Message.getWrapperField(this, proto.IntegrationResponse.TakConfig, 11));
};


/**
 * @param {?proto.IntegrationResponse.TakConfig|undefined} value
 * @return {!proto.IntegrationResponse} returns this
*/
proto.IntegrationResponse.prototype.setTakConfig = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.IntegrationResponse} returns this
 */
proto.IntegrationResponse.prototype.clearTakConfig = function() {
  return this.setTakConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.IntegrationResponse.prototype.hasTakConfig = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.IntegrationConnection.prototype.toObject = function(opt_includeInstance) {
  return proto.IntegrationConnection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IntegrationConnection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationConnection.toObject = function(includeInstance, msg) {
  var f, obj = {
integrationIdentityId: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IntegrationConnection}
 */
proto.IntegrationConnection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.IntegrationConnection;
  return proto.IntegrationConnection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IntegrationConnection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IntegrationConnection}
 */
proto.IntegrationConnection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIntegrationIdentityId(value);
      break;
    case 2:
      var value = /** @type {!proto.IntegrationConnection.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.IntegrationConnection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.IntegrationConnection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IntegrationConnection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.IntegrationConnection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIntegrationIdentityId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.IntegrationConnection.Status = {
  UNKNOWN: 0,
  CONNECTED: 1,
  DISCONNECTED: 2
};

/**
 * optional string integration_identity_id = 1;
 * @return {string}
 */
proto.IntegrationConnection.prototype.getIntegrationIdentityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.IntegrationConnection} returns this
 */
proto.IntegrationConnection.prototype.setIntegrationIdentityId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Status status = 2;
 * @return {!proto.IntegrationConnection.Status}
 */
proto.IntegrationConnection.prototype.getStatus = function() {
  return /** @type {!proto.IntegrationConnection.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.IntegrationConnection.Status} value
 * @return {!proto.IntegrationConnection} returns this
 */
proto.IntegrationConnection.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


goog.object.extend(exports, proto);
